import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../../http/app.auth.http.service';
import { AdjustmentType } from '../../models/adjustment-type';
import { AdjustmentTypeHttpServiceInterface } from './adjustment-type.http-service.interface';

@Injectable()
export class AdjustmentTypeHttpService implements AdjustmentTypeHttpServiceInterface {

  private adjustmentTypesUrl: string = this.environment.baseUrl + '/api/adjustment-type';

  constructor(private http: AppAuthHttpService,
    private environment: EnvironmentConfiguration,
    private responseUtilService: ResponseUtilService) {
  }

  getAllAdjustmentTypes(): Observable<AdjustmentType[]> {
    return this.get('/all');
  }

  getCreditAdjustmentTypes(): Observable<AdjustmentType[]> {
    return this.get('/credit');
  }

  getDebitAdjustmentTypes(): Observable<AdjustmentType[]> {
    return this.get('/debit');
  }

  private get(endpoint: string): Observable<AdjustmentType[]> {
    return this.http.get(`${this.adjustmentTypesUrl}${endpoint}`)
    .catch((error) => {
      this.responseUtilService.handleError(error);
      return Observable.throw(error);
    })
    .map((response) => {
      return response.json() as AdjustmentType[];
    })
    .share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/adjustment-type/adjustment-type.http-service.ts